import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiPlay, FiVideo, FiMapPin, FiEdit, FiCloud, FiMail } = FiIcons;

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/', icon: FiPlay },
    { name: 'Watch', path: '/watch', icon: FiPlay },
    { name: 'VOD', path: 'https://vod.borough.tv/channel/66ddf45007db27257ddb436a/playlist/6706d6bfb42fe49b30fed261/', icon: FiVideo, external: true },
    { name: 'Things to Do', path: '/things-to-do', icon: FiMapPin },
    { name: 'Blog', path: 'https://blog.boroughtv.nyc', icon: FiEdit, external: true },
    { name: 'Weather', path: '/weather', icon: FiCloud },
    { name: 'Contact', path: '/contact', icon: FiMail },
  ];

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="bg-dark-card border-b border-dark-border sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752863923352-BTV-Logo.png"
              alt="BoroughTV Logo"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              item.external ? (
                <a
                  key={item.name}
                  href={item.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-gray-300 hover:text-accent-blue transition-colors duration-300"
                >
                  <SafeIcon icon={item.icon} className="text-sm" />
                  <span>{item.name}</span>
                </a>
              ) : (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`flex items-center space-x-2 transition-colors duration-300 ${
                    location.pathname === item.path
                      ? 'text-accent-blue'
                      : 'text-gray-300 hover:text-accent-blue'
                  }`}
                >
                  <SafeIcon icon={item.icon} className="text-sm" />
                  <span>{item.name}</span>
                </Link>
              )
            ))}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-gray-300 hover:text-accent-blue transition-colors duration-300"
            >
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-xl" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="md:hidden bg-dark-card border-t border-dark-border"
        >
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navItems.map((item) => (
              item.external ? (
                <a
                  key={item.name}
                  href={item.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 px-3 py-2 text-gray-300 hover:text-accent-blue hover:bg-dark-bg rounded-md transition-colors duration-300"
                  onClick={() => setIsOpen(false)}
                >
                  <SafeIcon icon={item.icon} className="text-sm" />
                  <span>{item.name}</span>
                </a>
              ) : (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`flex items-center space-x-3 px-3 py-2 rounded-md transition-colors duration-300 ${
                    location.pathname === item.path
                      ? 'text-accent-blue bg-dark-bg'
                      : 'text-gray-300 hover:text-accent-blue hover:bg-dark-bg'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  <SafeIcon icon={item.icon} className="text-sm" />
                  <span>{item.name}</span>
                </Link>
              )
            ))}
          </div>
        </motion.div>
      )}
    </nav>
  );
}

export default Navbar;